export const defaultState = () => {
  return {
    survey: {
      mainSurvey: null,
      subSurvey: null,
    }
  }
};

const state = defaultState();

export default state;
